import { render, staticRenderFns } from "./m-article-section.vue?vue&type=template&id=95adbad8&scoped=true"
import script from "./m-article-section.vue?vue&type=script&lang=js"
export * from "./m-article-section.vue?vue&type=script&lang=js"
import style0 from "./m-article-section.vue?vue&type=style&index=0&id=95adbad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95adbad8",
  null
  
)

export default component.exports